module.exports = __webpack_public_path__ + "files/7a3b8b127c60971e89735925b5816bfd.png";